import { z } from 'zod';
import { requiredString } from '../helpers';
export const Salesforce_Create_Case_1_ConfigValidator = z.object({
    connection: requiredString('Salesforce Connection is required'),
    contactId: z.string().optional(),
    subject: requiredString('Subject is required'),
    description: z.string().optional(),
    priority: z.string().optional(),
    origin: z.string().optional(),
    additionalFields: z.record(z.string(), z.string().optional()).optional()
});
//# sourceMappingURL=salesforce-create-case-1.js.map